import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useGetBuslineScheduleSuspense } from '@area-restrita/api-client/endpoints/busline-schedules/busline-schedules.gen';

import BuslineMap from '@/modules/busline-schedules/pages/BuslineMap';

export const Route = createFileRoute(
  '/_authenticated/_system/busline-schedules/$buslineScheduleId',
)({
  head: () => ({
    meta: [{ title: 'Linha e Horário' }],
  }),
  params: {
    parse: z.object({ buslineScheduleId: z.coerce.number() }).parse,
  },
  component: function BuslineScheduleRoute() {
    const { buslineScheduleId } = Route.useParams();

    const { data: buslineSchedule } =
      useGetBuslineScheduleSuspense(buslineScheduleId);

    return <BuslineMap buslineSchedule={buslineSchedule} />;
  },
});
